import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { Col, Row, Space, Switch } from 'antd'
import { ActionButton, PrimaryButton } from 'Components/button'
import {
  CreateRolePackageReq,
  DeleteRolePackageReq,
  RolePackageData,
  RolePackageListReq,
  UpdateRolePackageReq,
} from 'Store/manage-role-package/types'
import {
  createRolePackageAPI,
  deleteRolePackageAPI,
  updateRolePackageAPI,
} from 'Store/manage-role-package/api'
import {
  selectRolePackageActionEvent,
  selectRolePackageList,
  selectRolePackageListEvent,
} from 'Store/manage-role-package/selector'
import { selectCurrentUser } from 'Store/user/selector'
import EventModal from 'Components/modal/EventModal'
import { clearEventAction } from 'Store/manage-role-package/actions'
import LoadingView from 'Components/modal/LoadingView'
import { DetailDrawer } from 'Components/common/MainLayout'
import { TableListPage } from 'Components/common/Table'
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons'
import { ConfirmDailog } from 'Components/modal'
import { RolePackage } from 'Store/manage-role-package/types'
import { rolePackageListAPI } from 'Store/manage-role-package/api'
import SelectRoles from './SelectRoles'
import styled from 'styled-components'
import { DefaultStatus } from 'helpers/constanst'

type Props = ReduxProps & {
  visible: boolean
  onCloseDrawer: () => void
  onSuccess?: () => void
  mode: any
  id?: number
}

const RolePackagesDetail: React.FunctionComponent<Props> = props => {
  const { onCloseDrawer, visible, currentUser, event, onSuccess = () => {}, id = 0, listEvent, list } = props
  const [selectedID, setSelectedID] = useState(0)
  const [selectPermissionDrawer, setSelectPermissionDrawer] = useState(false)
  const [confirmDeleteDialog, setConfirmDeleteDialog] = useState(false)
  const [filter, setFilter] = useState({
    order_by: 'id',
    sort: 'desc',
    method: '',
    path: '',
    slug: '',
    status: '',
  })
  const dispatch = useDispatch()

  const onGetList = (): void => {
    const req: RolePackageListReq = {
      package_id: id,
      order_by: filter.order_by || 'id',
      sort: 'asc',
      all: true,
    }
    dispatch(rolePackageListAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.id || ''))
  }

  const onCreate = (role_id: number): void => {
    const req: CreateRolePackageReq = {
      role_id: role_id,
      package_id: id,
    }
    dispatch(createRolePackageAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  const onDelete = (id: number): void => {
    const req: DeleteRolePackageReq = {
      id,
    }
    dispatch(deleteRolePackageAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  const onUpdate = (id: number, status: boolean): void => {
    const req: UpdateRolePackageReq = {
      id,
      status: status ? DefaultStatus.ACTIVE : DefaultStatus.INACTIVE,
    }
    dispatch(updateRolePackageAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  const clearEvent = (): void => {
    dispatch(clearEventAction())
  }

  const onEventSuccess = (): void => {
    clearEvent()
    onSuccess()
    onGetList()
  }

  const title = 'Roles ที่สามารถใช้งานได้'

  const onClickDelete = (id: number) => {
    setSelectedID(id)
    onOpenConfirmDelete()
  }

  const onOpenConfirmDelete = () => {
    setConfirmDeleteDialog(true)
  }

  const onCloseConfirmDelete = () => {
    setConfirmDeleteDialog(false)
  }

  useEffect(() => {
    if (visible && id) {
      onGetList()
    }
  }, [visible, filter?.order_by, filter?.sort])

  const renderActionButton = (text: string, record: any) => (
    <Space size="middle">
      <ActionButton
        text=""
        icon={<DeleteOutlined />}
        label="ลบ"
        action="deleted"
        onClick={() => onClickDelete(record.id)}
      />
    </Space>
  )

  const onConfirmDelete = () => {
    onDelete(selectedID)
    onCloseConfirmDelete()
  }

  const ConfirmDeleteModal = (
    <ConfirmDailog
      isShow={confirmDeleteDialog}
      handleOk={onConfirmDelete}
      handleCancel={onCloseConfirmDelete}
    />
  )

  const renderStatus = (status: string, record: RolePackageData) => {
    const isActive = status === DefaultStatus.ACTIVE
    return (
      <Row justify="start">
        <Col md={24} xs={24}>
          <SwitchStyled>
            <Switch
              checked={isActive}
              onChange={(val: boolean) => {
                onUpdate(record?.id || 0, val)
              }}
            />
          </SwitchStyled>
        </Col>
      </Row>
    )
  }

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: '60px',
    },
    {
      title: 'ชื่อ Roles',
      dataIndex: 'roles',
      key: 'roles',
      render: (val: RolePackage) => val?.name || '',
    },
    {
      title: 'เปิดใช้งาน',
      key: 'status',
      dataIndex: 'status',
      render: renderStatus,
    },
    {
      title: '',
      key: 'action',
      width: '60px',
      render: renderActionButton,
    },
  ]

  const ManageDrawer = (
    <SelectRoles
      visible={selectPermissionDrawer}
      onCloseDrawer={() => setSelectPermissionDrawer(false)}
      onSelect={(id: number) => onCreate(id)}
      currentSelected={list.data || []}
    />
  )

  const onSort = (order_by: string, sort: string) => {
    setFilter({
      ...filter,
      sort,
      order_by,
    })
  }

  return (
    <DetailDrawer
      title={title}
      onCloseDrawer={onCloseDrawer}
      visible={visible}
      footer={null}
      width={'60%'}
      maskClosable={true}
    >
      <LoadingView isShow={listEvent.IsLoading} />
      <EventModal event={[event]} enable={true} successCalback={onEventSuccess} errorCalback={clearEvent} />
      <Row justify="end" gutter={16}>
        <Col>
          <Space size="middle">
            <PrimaryButton
              text="เพิ่ม Roles"
              icon={<PlusOutlined />}
              onClick={() => setSelectPermissionDrawer(true)}
            />
          </Space>
        </Col>
        <Col md={24} xs={24}>
          <TableListPage
            columns={columns}
            size={'small'}
            datas={list.data}
            isLoading={listEvent.IsLoading}
            paginationContent={null}
            scrollX={400}
            onSort={onSort}
          />
        </Col>
      </Row>
      {ConfirmDeleteModal}
      {ManageDrawer}
    </DetailDrawer>
  )
}

const SwitchStyled = styled.div`
  margin: 10px 0;
`

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    event: selectRolePackageActionEvent(state),
    list: selectRolePackageList(state),
    listEvent: selectRolePackageListEvent(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(RolePackagesDetail)
